import Action from "../actions";

export default function productProfileReducer(state = {
   
    profilesDetail: {
       
    }
}, action) {
    if (action.type === Action.SET_PRODUCT_PROFILE) {
        return action.data;
    }
    return state;
}
